import { useQuery } from '@tanstack/react-query';
import fetchAPI from '../fetchAPI';

export interface BillingAccountsSummary {
  total: number;
  live: number;
  staging: number;
  inactive: number;
  core: number;
  negotiator: number;
  multiProduct: number;
}

export const useBillingAccountsSummary = () => {
  return useQuery({
    queryKey: ['billing-accounts/summary'],
    queryFn: async () => {
      const response = await fetchAPI<BillingAccountsSummary>({
        method: 'GET',
        route: 'billing-accounts/summary'
      });
      return response;
    },
    staleTime: 5 * 60 * 1000
  });
};

export default useBillingAccountsSummary;
